module.exports = __webpack_public_path__ + "img/流体力学1_5_2.e3dd1967.jpg";